export default __webpack_public_path__ + "static/media/5d2d955df2895ca18dec554b0e716042.8597e02f.jpg";